import { render, staticRenderFns } from "./UniqueLinkStartingPage.vue?vue&type=template&id=2059f6a0&scoped=true&"
import script from "./UniqueLinkStartingPage.vue?vue&type=script&lang=js&"
export * from "./UniqueLinkStartingPage.vue?vue&type=script&lang=js&"
import style1 from "./UniqueLinkStartingPage.vue?vue&type=style&index=1&id=2059f6a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059f6a0",
  null
  
)

export default component.exports